<div class="surface-card p-3 shadow-2 border-round rt-summary">
  Containers with no resources, which break the booking process.
  @if (rows.length == 0) {
    <span class="rt-ok"><i class="pi pi-check-circle"></i> Every container has resources.</span>
  }
  @if (rows.length > 0) {
    <span class="rt-bad"><i class="pi pi-exclamation-triangle"></i> {{rows.length}} empty {{rows.length == 1 ? 'container' : 'containers'}}.</span>
  }
</div>

@if (shown.length > 0) {
  <div class="surface-card p-3 shadow-2 border-round rt-summary">
    <table class="rt-copies rt-results">
      <colgroup>
        <col style="width: 30%">
        <col>
        <col style="width: 6%">
      </colgroup>
      <tr>
        <th>Held in</th>
        <th>Where</th>
        <th></th>
      </tr>
      @for (s of shown; track trackKey($index, s)) {
        <tr class="rt-row-bad rt-group-start">
          <td>
            <span class="rt-kind">{{s.row.holder.kind}}</span>
            {{s.row.holder.name}}
            @if (s.row.holder.disabled) {
              <span class="rt-dim"> (disabled)</span>
            }
          </td>
          <td>
            @if (s.row.path === '') {
              The container itself
            } @else {
              {{s.row.trail.slice(1).join(' › ')}}<div class="rt-dim rt-path">{{s.row.path}}</div>
            }
          </td>
          <td><button type="button" class="rt-json-btn" (click)="toggle(s)">{{opened.has(s.key) ? 'Hide' : 'JSON'}}</button></td>
        </tr>
        @if (opened.has(s.key)) {
          <tr class="rt-json-row">
            <td colspan="3">
              <div class="rt-json">
                <app-json-node [value]="s.row.holder.data" [notes]="opened.get(s.key).notes" [good]="opened.get(s.key).good" [expand]="opened.get(s.key).expand"></app-json-node>
              </div>
            </td>
          </tr>
        }
      }
    </table>
  </div>
}
